// Уникальный session id для realtime echo prevention.
// Хранится в sessionStorage — каждая вкладка получает свой id.
// Используется и в WS (?session=...) и в HTTP (header x-socket-session-id).

const KEY = 'mykanban.socket_session_id';

export function getSessionId(): string {
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id = `web-${crypto.randomUUID()}`;
    sessionStorage.setItem(KEY, id);
  }
  return id;
}
